import * as React from 'react';
import Routes from '../../constants/Routes';
import { LegalLinks, LegalNavLink } from '../../components/UI/LegalUI';

const LegalNav: React.SFC = () => (
  <LegalLinks>
    <LegalNavLink to={Routes.privacy}>Privacy</LegalNavLink>
    <LegalNavLink to={Routes.terms}>Terms</LegalNavLink>
  </LegalLinks>
);

export default LegalNav;



// WEBPACK FOOTER //
// ./src/containers/Site/LegalNav.tsx